import { Box, Divider, Flex, FlexProps, Text } from '@chakra-ui/react';
import { FC } from 'react';

export const DividerWithText: FC<FlexProps> = ({ children, ...flexProps }) => (
  <Flex
    align="center"
    width="100%"
    {...flexProps}
    className="divider divider--with-text"
  >
    <Box flex="1">
      <Divider borderColor="currentColor" />
    </Box>
    <Text as="span" px={5} className="divider--with-text__text">
      {children}
    </Text>
    <Box flex="1">
      <Divider borderColor="currentColor" />
    </Box>
  </Flex>
);
